import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { NAV_LINKS, CONTACT_INFO, BRAND } from "../data/content";

export const Footer = () => (
  <footer className="relative bg-white noise-overlay overflow-hidden" data-testid="main-footer">
    <div className="relative z-10 max-w-[1400px] mx-auto px-6 md:px-12 pt-24 pb-10">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <img src={BRAND.logo} alt="Tangensis Business Solutions" className="h-16 md:h-20 w-auto" />
          </div>
          <p className="mt-6 text-brand-ink/75 max-w-sm leading-relaxed">
            Transforming business challenges into strategic opportunities through innovative, practical and results-driven solutions.
          </p>
        </div>

        <div className="md:col-span-3 md:col-start-7">
          <h4 className="text-sm uppercase tracking-[0.2em] text-brand-magenta font-semibold">Navigation</h4>
          <ul className="mt-6 space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.path}>
                <Link to={l.path} className="text-brand-ink/75 hover:text-brand-primary transition-colors duration-300 inline-flex items-center gap-1 group">
                  {l.label} <ArrowUpRight className="h-3.5 w-3.5 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300" />
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-sm uppercase tracking-[0.2em] text-brand-magenta font-semibold">Get in touch</h4>
          <ul className="mt-6 space-y-3 text-brand-ink/75">
            <li>{CONTACT_INFO.email}</li>
            <li>{CONTACT_INFO.phone}</li>
            <li className="leading-relaxed">{CONTACT_INFO.address}</li>
          </ul>
        </div>
      </div>

      <div className="mt-16 mb-4 select-none flex flex-col items-center text-center" aria-hidden="true">
        <h2 className="footer-wordmark leading-none text-[13vw] md:text-[8.5vw]">
          Tangensis
        </h2>
        <p className="text-brand-ink/25 tracking-[0.55em] text-[0.6rem] md:text-xs -mt-1 md:-mt-2 ml-[0.3em]">{BRAND.tagline}</p>
      </div>

      <div className="border-t border-brand-ink/10 pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-brand-ink/70">
        <p>© 2018 Tangensis Business Solutions. All rights reserved.</p>
        <div className="flex gap-6">
          <a href="#" className="hover:text-brand-primary transition-colors duration-300">Privacy Policy</a>
          <a href="#" className="hover:text-brand-primary transition-colors duration-300">Terms &amp; Conditions</a>
        </div>
      </div>
    </div>
  </footer>
);
